import React from 'react';
interface CTAButtonProps {
  text: string;
  isCheckout?: boolean;
}
export function CTAButton({
  text,
  isCheckout = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!isCheckout) {
      e.preventDefault();
      const section = document.getElementById('compra');
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <div className="text-center my-4" data-id="element-90">
      <a href={isCheckout ? 'https://digitalespro.com/cart/48038931071190:1' : '#compra'} onClick={handleClick} className="inline-block bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-black text-xl md:text-2xl px-12 py-6 rounded-full shadow-2xl transform hover:scale-105 transition-all duration-300 animate-pulse" data-id="element-91">
        {text}
      </a>
    </div>;
}
export default CTAButton;